export function getAvatarUrl(results, type, id) {
  var _results$find;
  return ((_results$find = results.find(r => r.type === type && r.id === id)) === null || _results$find === void 0 ? void 0 : _results$find.avatarUrl) || undefined;
}
export function buildAvatarEntities(companies, contacts) {
  const companyEntities = companies.flatMap(c => {
    return [{
      id: c.companyId,
      type: 'COMPANY'
    }];
  });
  const contactEntities = contacts.flatMap(c => [{
    id: c.contactVid,
    type: 'CONTACT',
    email: c.email
  }]);
  return [...companyEntities, ...contactEntities];
}